import { PATHS } from '../../../AppConstants';

export const rightSectionData = [
	{
		heading: 'DESIGNED FOR EVERY BUSINESSES',
		subHeading: 'myBiz offers features specially designed to benefit businesses of all sizes: MSMEs, SMEs & Large Corporates',
		linkText: 'View Benefits',
		linkUrl: `${PATHS.RESOURCE_PAGE}#BusinessDesign`,
		bottom_M: '24',
		trackEvt: 'view_benefits_clicked'
	},
	{
		heading: 'CUSTOMER STORIES',
		subHeading: 'Know how myBiz customers have benefited from our one-stop business travel management solution',
		linkText: 'View Stories & Reviews',
		linkUrl: `${PATHS.RESOURCE_PAGE}#CustomerStories`,
		trackEvt: 'view_stories_reviews_clicked'
	},
	{
		heading: 'INTEGRATIONS',
		subHeading: 'SSO Login, HRMS Integration, Expense management Integration & travel request API',
		linkText: 'Explore myBiz Docs',
		linkUrl: `${PATHS.TRAVEL_INTEGRATION_LANDING}`,
		trackEvt: 'view_explore_integration_clicked'
	}
];

export const leftSectionData = {
	businesPartnersData: {
		heading: 'PARTNER TO',
		linkText: 'View all Partners',
		linkUrl: `${PATHS.RESOURCE_PAGE}#BusinessPartners`,
		trackEvt: 'view_all_partners_clicked'
	},
	productVideoData: {
		heading: 'PRODUCT VIDEOS',
		linkText: 'View All Product Videos',
		linkUrl: `${PATHS.RESOURCE_PAGE}#ProductVideo`,
		bottom_M: '24',
		trackEvt: 'view_all_videos_clicked'
	},
	myBizBlogsData: {
		heading: 'MYBIZ BLOGS',
		linkText: 'View All Blogs',
		linkUrl: `${PATHS.RESOURCE_PAGE}#MyBizBlog`,
		trackEvt: 'view_all_videos_clicked'
	}
};
